import { useQuery } from '@tanstack/react-query';
import { getServices } from '@terminal/services/alfred-intergations/alfred-integrations-service';

export const QUERY_KEY_MICROSOFT_SERVICES = 'QUERY_KEY_MICROSOFT_SERVICES';

export const useMicrosoftServices = (userId?: string) =>
  useQuery({
    queryKey: [QUERY_KEY_MICROSOFT_SERVICES, userId],
    enabled: !!userId,
    queryFn: getServices,
    select: data =>
      data.data?.flatMap(integration => integration.services) ?? [],
  });
